module.exports = __webpack_public_path__ + "ede71849659911300be77523f48c48d2.svg";